import { Skeleton } from "@ds";

export function PageLoading() {
  return (
    <section className="page-loading" aria-busy="true" aria-live="polite">
      <div className="container">
        <div className="page-loading__stack">
          <Skeleton width={120} height={10} radius="sm" />
          <Skeleton width="68%" height={42} radius="md" />
          <Skeleton width="42%" height={42} radius="md" />
          <div className="page-loading__row">
            <Skeleton width={140} height={36} radius="md" />
            <Skeleton width={120} height={36} radius="md" />
          </div>
          <div className="page-loading__grid">
            <Skeleton height={160} radius="lg" />
            <Skeleton height={160} radius="lg" />
            <Skeleton height={160} radius="lg" />
          </div>
        </div>
      </div>
    </section>
  );
}
